import React from 'react';
import { usePlanningContext } from '../state/PlanningContext';
import { isPlanningFeedAddedToday } from '../../../utils/addedToday';

const EnhancedStatsBar = () => {
  const {
    applications,
    newThisWeekGroupCount,
    referenceDate,
    feedSummary,
    usesRemoteSummary,
  } = usePlanningContext();

  const stats = [
    { label: 'Total applications', value: usesRemoteSummary ? feedSummary?.counts.total : applications.length },
    {
      label: 'Added today',
      value: usesRemoteSummary ? feedSummary?.counts.today : applications.filter(app => isPlanningFeedAddedToday(app, referenceDate)).length,
    },
    { label: 'New this week', value: usesRemoteSummary ? feedSummary?.counts.recent : newThisWeekGroupCount },
  ];

  return (
    <div className="grid grid-cols-3 divide-x divide-[var(--c-border)] border border-[var(--c-border)] bg-[var(--c-surface)]" key="stats-bar">
      {stats.map((stat, idx) => (
        <div key={`enhanced-stat-${idx}`} className="px-4 py-3">
          <p className="pr-kicker mb-1">{stat.label}</p>
          <p className="font-['DM_Mono'] text-2xl font-medium tabular-nums text-[var(--c-text-primary)]">
            {stat.value == null ? '—' : Number(stat.value).toLocaleString('en-GB')}
          </p>
        </div>
      ))}
    </div>
  );
};

export default EnhancedStatsBar;
